<template>
  <component
    :key="item.key"
    v-bind="item.props"
    :is="getComponent(item.component)"
    :value="get($path('props.key', item) || item.key)"
    :data-field="item.key"
    :disabled="Boolean(item.disabled || getDisabledField(item.key))"
    @input="$ev => set($path('props.key', item) || item.key, $ev)"
    v-tooltip.bottom="item.disabled || getDisabledField(item.key)"
    :data="value"
    :validator="validator"
    :get-disabled-field="getDisabledField"
  >
    <template v-for="(slotItems, slot) in item.slots" v-slot:[slot]="slotScope">
      <component
        v-for="(slotItem, index) of slotItems"
        :key="item.key + slot + index"
        v-bind="{ ...slotItem.props, ...slotScope }"
        :is="getComponent(slotItem.component)"
        :value="$path('props.value', slotItem) || get(slotItem.key)"
        :disabled="Boolean(getDisabledField(item.key))"
        @input="$ev => set($path('props.value', slotItem) || get(slotItem.key), $ev)"
      />
    </template>
  </component>
</template>

<script>
import { mapGetters } from 'vuex'
import Components from '@/components/Residential/Fields'
import { CheckboxComponent } from 'vue-elder-checkbox'

export default {
  computed: {
    ...mapGetters('Residential', ['getDisabledField']),
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    placement: {
      type: String,
    },
  },
  methods: {
    get(key) {
      if (!key) return
      return this.$path(key, this.value)
    },
    set(key, value) {
      this.$emit('input', { key, value })
    },

    getComponent(item) {
      const items = {
        ...Components,
        CheckboxComponent,
      }

      return items[item] || item
    },
  },
}
</script>

<style lang="scss"></style>
